import {useState} from "react";
import * as style from "@FRAMEWORK/ui/mobile/footer";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import SSOLink from "@COMPONENTS/common/ssoLink";

const Footer = () => {
	const [isActive, setIsActive] = useState(false);
	const handleClick = () => {
		setIsActive(!isActive);
	};

	return (
		<style.FooterWrap>
			<style.Fnb>
				<nav>
					<ul>
						<li>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/main.yb`}>고객센터</SSOLink>
						</li>
						<li>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/noticeList.yb`}>공지사항</SSOLink>
						</li>
						<li>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/faqList.yb`}>자주하는질문</SSOLink>
						</li>
						<li>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/qnaGuide.yb`}>1:1문의</SSOLink>
						</li>
						<li>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/estimateWrite.yb`}>견적문의</SSOLink>
						</li>
						<li>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/eplg/episodeList.yb`}>여행후기</SSOLink>
						</li>
						<li>
							<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/praiseList.yb`}>칭찬합시다</SSOLink>
						</li>
						<li>
							<SSOLink
								href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/freeInstallmentPopup.yb`}
								target="_blank"
								rel="noreferrer"
							>
								무이자할부
							</SSOLink>
						</li>
						<li>
							<SSOLink
								href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=`}
								target="_self"
							>
								현금영수증
							</SSOLink>
						</li>
					</ul>
				</nav>
			</style.Fnb>
			<style.LinkWrap>
				<style.Policies>
					<SSOLink href={publicRuntimeConfig.ENV_COMPANY_URL}>회사소개</SSOLink>
					<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/common/privacy.yb`}>
						<span>개인정보처리방침</span>
					</SSOLink>
					<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/common/internetAgree.yb`}>이용약관</SSOLink>
					<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/common/travelAgree.yb`}>여행약관</SSOLink>
					<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/common/travelerInsuInfo.yb`}>여행자보험</SSOLink>
					<SSOLink href={`${publicRuntimeConfig.ENV_COMPANY_URL}/agent/about`} target="_blank" rel="noreferrer">
						대리점안내
					</SSOLink>
				</style.Policies>
				<style.Sns>
					<style.SnsItem
						sns="facebook"
						href="https://www.facebook.com/yellowballoonofficial/"
						target="_blank"
						rel="noreferrer"
					>
						페이스북
					</style.SnsItem>
					<style.SnsItem
						sns="instagram"
						href="https://www.instagram.com/yellowballoon_official"
						target="_blank"
						rel="noreferrer"
					>
						인스타그램
					</style.SnsItem>
					<style.SnsItem sns="youtube" href="https://www.youtube.com/user/ybtour2013" target="_blank" rel="noreferrer">
						유튜브
					</style.SnsItem>
					<style.SnsItem sns="kakao" href="https://pf.kakao.com/_hhAxbd" target="_blank" rel="noreferrer">
						카카오톡
					</style.SnsItem>
					<style.SnsItem sns="blog" href="http://m.blog.naver.com/yb_tour" target="_blank" rel="noreferrer">
						네이버 블로그
					</style.SnsItem>
				</style.Sns>
			</style.LinkWrap>
			<section>
				<style.Corporation>
					<style.ToggleBtn type="button" onClick={handleClick} $isActive={isActive}>
						(주)노랑풍선
						<img src="https://cimgcdn.ybtour.co.kr/common/footer/logo_kosdaq_.png" alt="KOSDAQ 코스닥 상장법인" />
					</style.ToggleBtn>
				</style.Corporation>
				{isActive && (
					<style.ToggleBox>
						<style.CompanyArea>
							<div>
								<style.Yb>
									<span>대표이사 김진국</span>서울특별시 중구 수표로 31, 노랑풍선빌딩
								</style.Yb>
								사업자등록번호 104-81-64440
								<style.TxtLink
									href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1048164440"
									target="_blank"
									rel="noreferrer"
								>
									사업자 정보확인
								</style.TxtLink>
								<br />
								관광사업자등록증번호 제2006-000003호
								<br />
								통신판매업신고번호 제2008-서울중구-0278
							</div>
							<div>
								<address>
									&#91;부산지사&#93; 부산광역시 부산진구 중앙대로668, 9층 912호 <br />
									&#40;부전동, 에이원프라자&#41;
								</address>
								사업자등록번호 870-85-01900
							</div>
							<div>
								<p>
									영업배상책임보험: 총 20억원
									<br />
									공제영업보증가입: 15억 1천만원
									<br />
									공제기획 여행보증: 7억원
								</p>
								<style.LogoList>
									<li>
										<SSOLink href="http://tourinfo.or.kr/standard/partners.asp" target="_blank" rel="noreferrer">
											<span>국외여행상품 정보제공 표준안 참여 여행사</span>
										</SSOLink>
									</li>
									<li>
										<SSOLink
											href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/noticeView.yb?pageNo=1&noticeNo=20000016702&searchNoticeCd=&searchCnd=&searchWrd=`}
											target="_self"
											rel="noreferrer"
										>
											<span>현금영수증 의무발행 가맹점</span>
										</SSOLink>
									</li>
								</style.LogoList>
							</div>
						</style.CompanyArea>
						<style.CsArea>
							<div>
								<SSOLink href={`${publicRuntimeConfig.ENV_PACKAGE_M_URL}/cs/main.yb`}>고객센터</SSOLink>
								<ul>
									<li>
										<p>패키지여행 상담</p>
										<span>
											<a href="tel:15442288">1544-2288</a>
										</span>
									</li>
									<li>
										<p>자유여행 상담</p>
										<span>
											<a href="tel:16443399">1644-3399</a>
										</span>
									</li>
									<li>
										<p>부산/지방출발 상담</p>
										<span>
											<a href="tel:0517130710">051-713-0710</a>
										</span>
									</li>
								</ul>
							</div>
						</style.CsArea>
						<style.MailArea>
							<li>
								<span>대표메일</span>
								<a href="mailto:master@ybtour.com">master@ybtour.com</a>
							</li>
							<li>
								<span>마케팅제휴</span>
								<a href="mailto:marketing@ybtour.com">marketing@ybtour.com</a>
							</li>
							<li>
								<span>판매제휴</span>
								<a href="mailto:salespartner@ybtour.com">salespartner@ybtour.com</a>
							</li>
							<li>
								<span>대리점문의</span>
								<a href="mailto:sales.agent@ybtour.co.kr">sales.agent@ybtour.co.kr</a>
							</li>
						</style.MailArea>
					</style.ToggleBox>
				)}
				<style.ExplainList>
					<li>
						노랑풍선은 개별 항공권, 단품 및 일부 여행상품에 대하여 판매중개자로서 통신판매의 당사자가 아닙니다. 따라서
						해당 상품의 상품·거래정보 및 거래 등에 대하여 책임을 지지 않습니다.
					</li>
					<li>
						항공권 또는 항공권이 포함된 상품의 경우, 표시되는 상품요금은 세금 및 예상 유류할증료가 포함된 가격이며,
						유류할증료는 유가 및 환율 등에 따라 변동될 수 있습니다.
					</li>
					<li>
						노랑풍선의 &apos;예금주&apos; 계좌가 아닌, 다른 계좌(개인, 대리점 등)로 입금하실 경우 발생하는 피해에 관하여
						당사는 책임지지 않습니다. 타 계좌의 입금을 유도하는 행위가 발생하는 경우, 반드시 입금 전에 노랑풍선
						고객센터로 문의하거나 신고하여 주시기 바랍니다.
					</li>
					<li>
						고객님의 안전하고 편안한 여행을 위해 꼭 알아두셔야 할 여행 안전 유의사항을 확인해주세요.
						<SSOLink href="https://mpkg.ybtour.co.kr/cs/travelSafetyGuide.yb" target="_blank" rel="noreferrer">
							자세히보기
						</SSOLink>
					</li>
				</style.ExplainList>
				<style.Copyright>Ⓒ Yellow Balloon tour. All Rights Reserved.</style.Copyright>
			</section>
		</style.FooterWrap>
	);
};

export default Footer;
